import { resolveStorageUrl } from "@/lib/storage/public-url";

/**
 * Trim + storage-resolve a profile image reference (`profiles.banner_url` /
 * `avatar_url`).
 *
 * Both consumers need an ABSOLUTE URL: `ProfileCoverBand` feeds it to
 * `next/image` (whose URL constructor throws on a bare path), and
 * `use-profile-chrome-colors` hands it to a colour extractor that downloads it.
 * Mirror of the mobile port, which already resolved here.
 *
 * @see lib/storage/url.ts
 * @see .tondocs/images/HANDOFF_RELATIVE_STORAGE_PATHS_2026_07_27.md §3 L3
 */
export function trimImageUrl(url: string | null | undefined): string {
  const trimmed = typeof url === "string" ? url.trim() : "";
  return trimmed ? resolveStorageUrl(trimmed) : "";
}
